import { useLocation, matchPath } from 'react-router-dom';

/**
 * Le dossier ouvert à l'écran, dérivé de l'URL (`/cases/:id`).
 *
 * WHY par la route et non par un contexte : les panneaux globaux (décision,
 * prévisualisation de pièce) sont montés dans la coque, HORS de la route du
 * dossier — ils ne peuvent donc pas lire ses paramètres, et Hector n'a pas de
 * store « dossier actif ».
 *
 * WHY c'est la source la plus fiable : le dossier voyageait jusqu'ici d'appelant
 * en appelant, et **une seule** des trois façons d'ouvrir une décision le
 * transmettait. Résultat, « Enregistrer » s'ouvrait sans dossier présélectionné
 * dès qu'on avait ouvert la décision autrement qu'en cliquant une citation du
 * chat. L'URL, elle, dit toujours la vérité quand on est dans un dossier.
 *
 * Rend `undefined` hors d'un dossier (assistant global, réglages…) — l'appelant
 * se rabat alors sur ce qu'il sait par ailleurs.
 */
export function useRouteCaseId(): string | undefined {
  const location = useLocation();
  return matchPath({ path: '/cases/:id', end: false }, location.pathname)?.params.id;
}
